import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import SEO from "@/components/SEO";

export default function AdminCategories() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", name_en: "", slug: "" });

    const load = () => api.get("/categories").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const save = async (e) => {
        e.preventDefault();
        try { await api.post("/admin/categories", form); toast.success("Created"); setOpen(false); setForm({ name: "", name_en: "", slug: "" }); load(); }
        catch (err) { toast.error(formatApiError(err)); }
    };

    const del = async (id) => {
        if (!confirm("Delete this category?")) return;
        await api.delete(`/admin/categories/${id}`); load();
    };

    return (
        <div>
            <SEO title="Admin - Categories" />
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-bold text-brand-navy">Categories</h1>
                <button onClick={() => setOpen(true)} className="btn-primary px-4 py-2 rounded-lg font-semibold inline-flex items-center gap-2"><Plus className="w-4 h-4" /> Add</button>
            </div>
            <div className="bg-white rounded-2xl border border-brand-light overflow-x-auto">
                <table className="w-full text-sm min-w-[400px]">
                    <thead className="bg-brand-light/40">
                        <tr><th className="text-left px-4 py-3">Name (BN)</th><th className="text-left px-4 py-3">Name (EN)</th><th className="text-left px-4 py-3">Slug</th><th></th></tr>
                    </thead>
                    <tbody>
                        {items.map((c) => (
                            <tr key={c.id} className="border-t border-brand-light">
                                <td className="px-4 py-3 font-medium">{c.name}</td>
                                <td className="px-4 py-3">{c.name_en}</td>
                                <td className="px-4 py-3 text-xs text-brand-royal">{c.slug}</td>
                                <td className="px-4 py-3 text-right"><button onClick={() => del(c.id)} className="p-1.5 hover:bg-brand-red/10 text-brand-red rounded"><Trash2 className="w-4 h-4" /></button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="font-bn w-[95vw] sm:w-full z-[100]">
                    <DialogHeader><DialogTitle>New Category</DialogTitle></DialogHeader>
                    <form onSubmit={save} className="space-y-3">
                        <input placeholder="Name (Bangla)" value={form.name} required onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-3 py-2 rounded-lg border border-brand-light" />
                        <input placeholder="Name (English)" value={form.name_en} required onChange={(e) => setForm({ ...form, name_en: e.target.value })} className="w-full px-3 py-2 rounded-lg border border-brand-light" />
                        <input placeholder="slug-format" value={form.slug} required onChange={(e) => setForm({ ...form, slug: e.target.value })} className="w-full px-3 py-2 rounded-lg border border-brand-light" />
                        <button className="btn-primary w-full py-2.5 rounded-lg font-semibold">Save</button>
                    </form>
                </DialogContent>
            </Dialog>
        </div>
    );
}
